<template>
  <tm-custom-tooltip
    :anchor-element="anchorElement"
    :color="color"
    :offset="offset"
    :direction="direction"
    :interactive="interactive"
    :disabled="disabled"
    :delay="delay"
    :persistence="persistence"
  >
    <div
      v-if="html"
      v-safe-html="{ html: text, config: safeHtmlConfig }"
      class="pre-line"
      :class="`text-${textAlign}`"
    />
    <div
      v-else
      class="pre-line"
      :class="`text-${textAlign}`"
    >
      {{ text }}
    </div>
  </tm-custom-tooltip>
</template>

<script setup lang="ts">
import type { TmTextTooltipPropsType } from '@/components/shared/tooltip/types'
import type { PurifierConfig } from '@/utils/string/types'
import TmCustomTooltip from '@/components/shared/tooltip/TmCustomTooltip.vue'

const { text = '', textAlign = 'center', html = false, delay } = defineProps<TmTextTooltipPropsType>()

const safeHtmlConfig: PurifierConfig = {
  ALLOWED_TAGS: ['a', 'b', 'br', 'em', 'i', 'p', 'strong', 'u'],
  ALLOWED_ATTR: ['href', 'target'],
}
</script>
